import { render, staticRenderFns } from "./FlightTemplateChange.vue?vue&type=template&id=0b72ef7e&scoped=true&"
import script from "./FlightTemplateChange.vue?vue&type=script&lang=js&"
export * from "./FlightTemplateChange.vue?vue&type=script&lang=js&"
import style0 from "./FlightTemplateChange.vue?vue&type=style&index=0&id=0b72ef7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72ef7e",
  null
  
)

export default component.exports